import { api } from "./api";

export const notificationListApi = (params) => {
  return api.get(`/distributor/notification/notification-list`, {
    params: params,
  });
};
